import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, projectFormData } from "./ProjectFile";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";
import GmailInput from "./../../custom/components/Gmail-Inputs/GmailInput";
import { validate } from "../../custom/validations/Validate";
import {
  dropdownData,
  getRecords,
  saveRecords,
} from "../../services/api.service";
import { toast } from "react-toastify";
import {
  isAlphabet,
  isEmail,
  isPhoneNumber,
} from "../../custom/validations/Ruls";

const ProjectCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(projectFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [customerSelectOptions, setCustomerSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    } else {
      getUserMasterDropData();
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        getUserMasterDropData(data?.customer_id);
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getUserMasterDropData = async (customerId) => {
    try {
      let payload = {
        modelName: "company_masters",
        whereCondition: {
          type: 2,
          is_active: true,
        },
        relations: [
          {
            module: "user_masters",
            moduleAs: "user",
          },
        ],
        subWhereCondition: {
          user_type: 3,
          is_active: true,
        },
      };

      const responseData = await getRecords(payload, "/listCustomers");
      if (responseData.data && responseData.data.length > 0) {
        // const processedData = responseData?.data?.map((item) => {
        //   const CompanyName = item?.company_masters?.company_name;
        //   return {
        //     ...item,
        //     company_name: CompanyName,
        //   };
        // });
        responseData.data = responseData?.data.filter((data) => data?.id != 1);
        const dropdownResponseData = await dropdownData(
          responseData?.data,
          "company_name"
        );
        if (id) {
          dropdownResponseData[0].options?.forEach((element) => {
            if (element.value == customerId) {
              setCustomerSelect(element);
            }
          });
        }
        setCustomerSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = validate(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));
    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? 1 : 0) : value,
      },
    }));
  };

  const handleCustomerSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      customer_id: selectedValue,
    });

    setCustomerSelect(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      customer_id: fieldError?.customer_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        customer_id: selectedValue,
      },
    }));
  };

  const handleAddContactPersonDetails = () => {
    const errors = {};
    formData?.inputData &&
      formData?.inputData?.contact_person_details &&
      formData?.inputData?.contact_person_details?.forEach((person, index) => {
        [
          "contact_person_name",
          "contact_person_email",
          "contact_person_mobile",
        ].forEach((field) => {
          if (!person[field]?.trim()) {
            errors.contact_person_details = {
              ...errors.contact_person_details,
              [index]: {
                ...errors.contact_person_details?.[index],
                [field]: `${field.replace(/_/g, " ")} is required`,
              },
            };
          }
        });
      });

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      //  toast.error(
      //    "Please fix errors in the existing contact person details before adding a new one."
      //  );
      return;
    }

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        contact_person_details: [
          ...prev.inputData.contact_person_details,
          {
            contact_person_name: "",
            contact_person_email: "",
            contact_person_mobile: "",
          },
        ],
      },
    }));
  };

  const handleRemoveContactPersonDetails = (index) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors.contact_person_details?.[index];

    setFormData((prev) => {
      const updatedDetails = prev.inputData.contact_person_details.filter(
        (_, i) => i !== index
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          contact_person_details: updatedDetails,
        },
      };
    });
    setFormErrors(updatedErrors);
  };

  const handleContactPersonDetailsOnChange = (e, index) => {
    const { name, value } = e.target;

    let errorMessage = "";

    if (name === "contact_person_email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        errorMessage = `Invalid ${[name?.replace(/_/g, " ")]} address.`;
      }
    }
    if (name === "contact_person_name") {
      const error = isAlphabet(value, name);
      if (error) {
        errorMessage = error;
      }
    }

    if (name === "contact_person_mobile") {
      const error = isPhoneNumber(value, name);

      if (error) {
        errorMessage = error;
      }
    }

    setFormErrors((prev) => ({
      ...prev,
      contact_person_details: {
        ...prev.contact_person_details,
        [index]: {
          ...prev.contact_person_details?.[index],
          [name]: value.trim()
            ? errorMessage || ""
            : `${[name.replace(/_/g, " ")]} is required`,
        },
      },
    }));

    setFormData((prev) => {
      const updatedDetails = [...prev.inputData?.contact_person_details];
      updatedDetails[index][name] = value;
      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          contact_person_details: updatedDetails,
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    try {
      setLoadingData(true);
      e.preventDefault();

      const validationErrors = validate(validationType, formData.inputData);
      if (Object.keys(validationErrors).length > 0) {
        setLoadingData(false);
        setFormErrors(validationErrors);
        return;
      }

      const errors = {};
      formData?.inputData?.contact_person_details?.forEach((person, index) => {
        const personErrors = {};

        [
          "contact_person_name",
          "contact_person_email",
          "contact_person_mobile",
        ].forEach((field) => {
          if (!person[field]?.trim()) {
            personErrors[field] = `${field.replace(/_/g, " ")} is required`;
          }

          if (field === "contact_person_mobile" && person[field]?.trim()) {
            const phoneError = isPhoneNumber(
              person[field],
              "contact_person_mobile"
            );
            if (phoneError) {
              personErrors.contact_person_mobile = phoneError;
            }
          }
          if (field === "contact_person_email" && person[field]?.trim()) {
            const emailError = isEmail(person[field], "contact_person_email");
            if (emailError) {
              personErrors.contact_person_email = emailError;
            }
          }

          if (field === "contact_person_name" && person[field]?.trim()) {
            const nameError = isAlphabet(person[field], "contact_person_name");
            if (nameError) {
              personErrors.contact_person_name = nameError;
            }
          }
        });

        if (Object.keys(personErrors).length > 0) {
          errors.contact_person_details = {
            ...errors.contact_person_details,
            [index]: personErrors,
          };
        }
      });

      if (Object.keys(errors).length > 0) {
        setLoadingData(false);
        setFormErrors(errors);
        return;
      }
      const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
      formData.inputData.created_by = userDetails.id || null;
      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
        inputData: formData?.inputData,
      };

      setLoadingData(true);
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code === 1) {
        let projectDetailsData =
          JSON.parse(localStorage.getItem("projectDetails")) || [];
        const userId =
          projectDetailsData?.length > 0
            ? projectDetailsData[0]?.user_id
            : null;
        const userType =
          projectDetailsData?.length > 0
            ? projectDetailsData[0]?.user_type
            : null;
        const projectId = responseData?.data?.id || null;

        // let newProject = {
        //   project_id: projectId,
        //   user_type: userType,
        //   user_id: userId,
        //   access: true,
        //   is_active: true,
        //   projectDetails: responseData.data,
        // };
        // new code
        if (responseData?.data) {
          // checking if the project_id is already exists in projectDetailsData
          const existingProjectIndex = projectDetailsData.findIndex(
            (project) => project.project_id === projectId
          );

          let updatedProjectDetailsData;
          let newProject;

          if (existingProjectIndex !== -1) {
            // If project_id exists, update the existing entry while preserving missing fields
            const existingProject = projectDetailsData[existingProjectIndex];

            newProject = {
              ...existingProject,
              projectDetails: {
                ...responseData.data,
              },
            };

            updatedProjectDetailsData = [...projectDetailsData];
            updatedProjectDetailsData[existingProjectIndex] = newProject;
          } else {
            // If project_id does not exist, add the new project
            newProject = {
              project_id: projectId,
              user_type: userType,
              user_id: userId,
              access: true,
              is_active: true,
              projectDetails: responseData.data,
            };

            updatedProjectDetailsData = [...projectDetailsData, newProject];
          }
          // Save the updated data to localStorage
          localStorage.setItem(
            "projectDetails",
            JSON.stringify(updatedProjectDetailsData)
          );
          localStorage.setItem(
            "projectID",
            JSON.stringify(
              updatedProjectDetailsData.find(
                (project) =>
                  project.access === true &&
                  project?.projectDetails?.is_active === true
              )?.projectDetails?.project_id || null
            )
          );

          const projectExistsWithAccess = projectDetailsData.some(
            (project) =>
              project.project_id === projectId && project.access === true
          );

          if (projectExistsWithAccess) {
            // If project already exists with access: true, navigate directly without reloading
            toast.success(
              `${headerName} ${id ? "updated" : "saved"} successfully!`
            );
            navigate(navigatePage?.back);
            window.location.reload();
          } else {
            // If project does not exist or access is not true, reload and navigate
            toast.success(
              `${headerName} ${id ? "updated" : "saved"} successfully!`
            );
            navigate(navigatePage?.back);
            window.location.reload();
          }
        }

        // old code
        // if (responseData?.data) {
        //   const updatedProjectDetailsData = [
        //     ...projectDetailsData,
        //     newProject,
        //   ];
        //   localStorage.setItem("projectDetails",JSON.stringify(updatedProjectDetailsData));
        // }
        // window.location.href = navigatePage?.back;

        // new code
        // toast.success(`${headerName} ${id ? "updated" : "saved"} successfully!`);
        // window.location.reload();
        // navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        {/* First Row */}
        <Col md="4" className="mt-3">
          <TextInput
            label="Project code"
            name="project_code"
            value={formData?.inputData?.project_code}
            onChange={onInputChange}
            placeholder="Project code"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.project_code}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Project name"
            name="project_name"
            value={formData?.inputData?.project_name}
            onChange={onInputChange}
            placeholder="Project name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.project_name}
          />
        </Col>
        <Col md="4" className="mt-3">
          <SelectInput
            label="Customer"
            value={customerSelect}
            options={customerSelectOptions}
            onSelect={(selected) => handleCustomerSelect(selected)}
            placeholder="Select customer"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors?.customer_id}
          />
        </Col>

        {/* Second Row */}
        {/* <Col md="4" className="mt-3">
          <TextInput
            label="Contact person name"
            name="bermad_contact_person_name"
            value={formData?.inputData?.bermad_contact_person_name}
            onChange={onInputChange}
            placeholder="Contact person name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.bermad_contact_person_name}
          />
        </Col>
        <Col md="4" className="mt-3">
          <GmailInput
            label="Contact person email id"
            name="bermad_contact_person_email"
            value={formData?.inputData?.bermad_contact_person_email}
            onChange={onInputChange}
            placeholder="Contact person email id"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.bermad_contact_person_email}
          />
        </Col>
        <Col md="4" className="mt-3">
          <TextInput
            label="Contact person mobile number"
            name="bermad_contact_person_mobile"
            value={formData?.inputData?.bermad_contact_person_mobile}
            onChange={onInputChange}
            placeholder="Contact person mobile number"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.bermad_contact_person_mobile}
          />
        </Col> */}
      </Row>

      <Row className="mt-4">
        <Col
          style={{
            marginLeft: "",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h6
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#333",
              backgroundColor: "#f8f9fa",
              padding: "5px 20px",
              paddingTop: "10px",
              borderRadius: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              display: "inline-block",
              margin: "0",
            }}
          >
            Contact Person Details
          </h6>
          <Button
            color="primary"
            className="waves-effect waves-light me-1"
            onClick={handleAddContactPersonDetails}
            style={{ background: "#006eb9" }}
          >
            Add
          </Button>
        </Col>

        <div
          className="table mt-2"
          style={{
            overflow: "auto",
            maxHeight: "383px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Contact person name <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Contact person email id <Asterisks asterisk={true} />
                </th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Contact person mobile number <Asterisks asterisk={true} />
                </th>
                <th colSpan="2" style={{ whiteSpace: "nowrap" }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {formData &&
                formData?.inputData &&
                formData?.inputData?.contact_person_details &&
                formData?.inputData?.contact_person_details?.map(
                  (item, index) => {
                    return (
                      <React.Fragment key={index + 1}>
                        <tr
                          style={{
                            borderBottom: "1px solid #cccccc",
                            // verticalAlign: "middle",
                          }}
                        >
                          <td>{index + 1}</td>
                          <td style={{ minWidth: "200px", maxWidth: "200px" }}>
                            <TextInput
                              name="contact_person_name"
                              value={item?.contact_person_name}
                              onChange={(e) =>
                                handleContactPersonDetailsOnChange(e, index)
                              }
                              placeholder="Contact person name"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              asterisk={true}
                              customError={
                                formErrors?.contact_person_details?.[index]
                                  ?.contact_person_name
                              }
                            />
                          </td>
                          <td style={{ minWidth: "200px", maxWidth: "200px" }}>
                            <GmailInput
                              name="contact_person_email"
                              value={item?.contact_person_email}
                              onChange={(e) =>
                                handleContactPersonDetailsOnChange(e, index)
                              }
                              placeholder="Contact person email"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              asterisk={true}
                              customError={
                                formErrors?.contact_person_details?.[index]
                                  ?.contact_person_email
                              }
                            />
                          </td>

                          <td style={{ minWidth: "200px", maxWidth: "200px" }}>
                            <TextInput
                              name="contact_person_mobile"
                              value={item?.contact_person_mobile}
                              onChange={(e) =>
                                handleContactPersonDetailsOnChange(e, index)
                              }
                              placeholder="Contact person mobile"
                              inputClassName="form-control"
                              labelClassName="form-label"
                              labelStyle={{ display: "none" }}
                              asterisk={true}
                              customError={
                                formErrors?.contact_person_details?.[index]
                                  ?.contact_person_mobile
                              }
                            />
                          </td>
                          <td>
                            <div
                              onClick={() =>
                                handleRemoveContactPersonDetails(index)
                              }
                            >
                              <Link className="text-danger">
                                <i className="mdi mdi-trash-can font-size-20"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  }
                )}
            </tbody>
          </table>
        </div>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default ProjectCreate;
